import React, { useEffect, useState } from 'react';
import axios from 'axios';
import fetch from 'isomorphic-unfetch';
import Link from 'next/link';
import Image from 'next/future/image';
import { SiteAPI } from '../config';
import FooterComponent from '@/components/Footer/FooterComponent';
import { CareersStyles } from '@/components/styles/CareersStyles';
import Header from '@/components/Header/Header';
import SEOHead from '@/components/SEOHead/SEOHead';
import { WordPressAPI } from '../config';
import dynamic from 'next/dynamic';
import styled from 'styled-components';

const TrustPilotComponent = dynamic(
  () => import('@/components/TrustPilot/TrustPilotComponent'),
  { ssr: false }
);

const FooterNewsModal = dynamic(import('@/components/FooterNewsModal'));

const TPStyles = styled.div`
background-color: #fff;
padding: 0px;
position: relative;
${props => props.theme.media.md} {
  padding: 20px 0px;
}

.tp-container {
  margin: 0 auto;
  max-width: 100%;
  display: block;
  
  ${props => props.theme.media.md} {
    max-width: 67%;
  }
}
`;

const Careers = ({ data, jobs }) => {
  const [filteredJobs, setFilteredJobs] = useState(jobs);
  const [filters, setFilters] = useState([]);
  const [activeTab, setActiveTab] = useState('All locations');
  const { acf, title } = data;

  const filterJobs = (tab) => {
    setActiveTab(tab)
    if (tab == 'All locations') {
      setFilteredJobs(jobs)
    } else {
      const newFilteredJobs = jobs.filter(job => job.city == tab);
      setFilteredJobs(newFilteredJobs)
    }
  };

  useEffect(() => {
    const newFilters = ['All locations'];
    jobs.map(job => {
      if (job.city == '') {
        job.city = 'Remote';
      }
      if (!newFilters.includes(job.city)) {
        newFilters.push(job.city);
      }
    });
    console.log(newFilters)
    setFilters(newFilters);
  }, []);

  return (
    <div>
      <SEOHead>
        <title>{title.rendered}</title>
        <meta name="description" content={acf.meta_description} key="description" />
        <script
          type="text/javascript"
          src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
        />
      </SEOHead>
      <Header PaidCampaign={1} phone_number={data.acf.phone_number_setup} />
      <CareersStyles>
        <h1 className="title">{acf.intro_title}</h1>
        <p className="intro-description">
          {acf.intro_description}
        </p>
        <div className="featured-image">
          <Image src={acf.featured_image}
                 decoding="sync"
                 loading="eager"
                 width={677}
                 height={400}
                 unoptimized={true}
                 layout="fill" />
        </div>
        <TPStyles>
          <div className="tp-container">
            <TrustPilotComponent
              templateID="5406e65db0d04a09e042d5fc"
              height="28px"
              alt
            />
          </div>
        </TPStyles>

        <h2 className="subtitle"
          dangerouslySetInnerHTML={{
            __html: acf.subtitle,
          }}></h2>
        <p className="description2">{acf.description_2}</p>
        <div className="filter-tabs">
          {filters.map(item => (
            <span
              className={item == activeTab ? 'tab active' : 'tab'}
              key={item}
              onClick={() => {
                filterJobs(item);
              }}
            >
              {item}
            </span>
          ))}
        </div>
        {filteredJobs.length ? (
          <div className="jobs-container">
            {
              filteredJobs.map(job => {
                let location = `${job.city}, ${job.state}`;
                if (job.city === '') {
                  location = 'Remote';
                }
                return (
                  <div className="job-post">
                    <h3>{job.title}</h3>
                    <div className="job-location">{`${location}`}</div>
                    <div className="job-type">{job.type}</div>
                    <Link
                      href={`http://1800accountant.applytojob.com/apply/${job.board_code}?source=mainsite`}
                      key={job.id}
                    >
                      <a target="_blank" rel="noopener noreferrer" className="apply-btn">Apply</a>
                    </Link>
                  </div>
                );
              })
            }
          </div>
        ) : (
          <h3 className="no-openings">
            Sorry, there are no openings at this time.
          </h3>
        )}

        <div class="founded-section">
          <div className="content">
            <h2 className="founded-title">{acf.founded_title}</h2>
            <p className="founded-description">{acf.founded_description}</p>
            <Link
              href="/about"
            >
              <a target="_blank" rel="noopener noreferrer" className="learmore-btn btn btn-primary">Learn more</a>
            </Link>
          </div>
          <img src={acf.founded_image} alt="careers founded" width="500px" height="500px" />
        </div>
      </CareersStyles>
      {/* Email Newsletter */}
      <FooterNewsModal />
      <FooterComponent phone_number={data.acf.phone_number_setup} />
    </div>
  );
}

export const getServerSideProps = async () => {
  const { data } = await axios.get(`${WordPressAPI.pages}/15222`);

  const res = await fetch(SiteAPI.careers);
  const jobs = await res.json();

  return {
    props: {
      data,
      jobs,
    },
  };
};


export default Careers;
